import { render, staticRenderFns } from "./CreateCard.vue?vue&type=template&id=7f18d40f&scoped=true&"
import script from "./CreateCard.vue?vue&type=script&lang=js&"
export * from "./CreateCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateCard.vue?vue&type=style&index=0&id=7f18d40f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f18d40f",
  null
  
)

export default component.exports